import { SignIn } from "@clerk/clerk-react";
import { createFileRoute } from "@tanstack/react-router";

// /signin — the public Clerk sign-in surface.
//
// In normal use the auth-gated layout in src/components/layout/
// authenticated-layout.tsx renders the same <SignIn /> inline for
// unauthenticated visitors, so this route only matters when a user lands
// here directly (bookmark, link from an email, "sign out" link in a doc).
//
// forceRedirectUrl="/" sends the freshly-signed-in user back to the authed
// layout, which then mounts the dashboard.
//
// routing="hash" — Clerk's <SignIn /> multi-step flow (factor-one, choose,
// sso-callback, …) navigates to sub-paths in path-routing mode, which
// TanStack Router can't match without a catch-all per step. Hash routing
// keeps the URL at /signin and moves the step into the URL fragment
// (/signin#factor-one), so the same route handles every step. This is
// also the documented default for @clerk/clerk-react.
export const Route = createFileRoute("/signin")({
  component: SignInRoute,
});

function SignInRoute() {
  return (
    <div className="flex min-h-svh items-center justify-center px-4 py-8">
      <SignIn routing="hash" signUpUrl="/signup" forceRedirectUrl="/" />
    </div>
  );
}
